import React from "react";

const CircleIcon = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20">
    <circle cx="10" cy="10" r="5" fill={color} />
  </svg>
);

export default CircleIcon;
